export default __webpack_public_path__ + "static/media/330_portfolio03-en-web.f329c622.png";